export default {
    UPDATE_MINIPLAYER_STATUS: 'UPDATE_MINIPLAYER_STATUS'
}